export default __webpack_public_path__ + "static/media/battle_process.b8991b7d.jpg";